var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"has-text-centered",staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.chartId}}),_c('br'),_c('div',{staticClass:"has-text-centered"},[_c('h5',[_c('b',[_vm._v(_vm._s(this.title))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }